import type { SignDocumentsStats } from "../Models/Domain";

import useSignDocuments from "../Store";

import { getSignDocumentsStats } from "@/Services/TherapyApi/SignDocuments";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import { hasValue } from "@/Utils/Objects";

async function FetchSignDocumentsStatsActionHandler(): Promise<SignDocumentsStats | undefined> {
  const signDocumentsStore = useSignDocuments();

  let stats = await getSignDocumentsStats().catch(() => undefined);

  if (!hasValue(stats) || isApiError(stats)) {
    stats = undefined;
  }

  signDocumentsStore.stats = stats;

  return stats;
}

export default FetchSignDocumentsStatsActionHandler;
